// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/TableOfContent/TableIfContentItem.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/TableOfContent/TableIfContentItem.tsx");
  import.meta.hot.lastModified = "1727904225311.0571";
}
// REMIX HMR END

import clsx from "clsx";
import Link from "~/components/Link";
import { formatTitleForTableOfContent } from "~/utils/utils";
export function TableOfContentItem({
  title,
  index,
  activeSection,
  pathname
}) {
  const hash = formatTitleForTableOfContent(title);
  return <li data-active={activeSection === hash} className={clsx("relative pl-4", "data-[active=true]:bg-neutral-200", "data-[active=true]:before:absolute", "data-[active=true]:before:left-0", "data-[active=true]:before:w-[2px]", "data-[active=true]:before:h-full", "data-[active=true]:before:bg-secondary-500", "hover:bg-neutral-200")} key={`${index}-${pathname}#${hash}`}>
      <Link className="w-full block text-sm py-1 !text-neutral-600" to={`${pathname}#${hash}`} key={`${pathname}#${hash}-${index}`}>
        <span>{title}</span>
      </Link>
    </li>;
}
_c = TableOfContentItem;
var _c;
$RefreshReg$(_c, "TableOfContentItem");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;